export default "__VITE_ASSET__k0b7fIAz__"